import { Avatar, Badge, Table } from '@iveco-ti/iveco-ds'
import { useTranslation } from 'react-i18next'

import { colorAvatarByName } from '@/common/utils/colorAvatarByName'
import { translateApplicationAccountUserRole } from '@/common/utils/translateApplicationAccountUserRole'
import { UserApplicationAccountUserPaginated } from '../hooks/usePaginateUserApplicationAccountUser'
import { ActionsApplicationAccount } from './ActionsApplicationAccount'

type ApplicationAccountUserRowProps = {
  userAccess: UserApplicationAccountUserPaginated
}

export function ApplicationAccountUserRow({
  userAccess,
}: ApplicationAccountUserRowProps) {
  const { t, i18n } = useTranslation('common')

  const regionName = new Intl.DisplayNames([i18n.language], {
    type: 'region',
  })

  return (
    <Table.Row hideCheckbox id={userAccess?.id}>
      <Table.Data className="flex gap-3 ">
        <Avatar
          src={userAccess?.UserPreference.avatarUrl || ''}
          name={userAccess?.UserPreference.displayName}
          color={colorAvatarByName(
            userAccess?.UserPreference.displayName || '',
          )}
        />

        <div className="flex flex-col justify-center mb-1">
          <span className="text-base-800 font-medium text-sm">
            {userAccess?.UserPreference.displayName}
          </span>

          <span className="text-base-400 font-light text-sm">
            {userAccess?.email}
          </span>
        </div>
      </Table.Data>

      <Table.Data className="flex flex-wrap w-full items-center justify-start gap-4">
        {userAccess?.ApplicationAccountUsers.map((appUser) => (
          <Badge.Root
            key={appUser.id}
            shape="square"
            size="sm"
            className=" flex justify-center"
          >
            {appUser.Application.title}{' '}
            {appUser.Account ? regionName.of(appUser.Account.country) : ''} -{' '}
            {translateApplicationAccountUserRole(t, appUser.role)}
          </Badge.Root>
        ))}
      </Table.Data>

      <Table.Data className="w-fit ml-auto" end>
        <ActionsApplicationAccount userAccess={userAccess} />
      </Table.Data>
    </Table.Row>
  )
}
